import { render, staticRenderFns } from "./AboutImage.vue?vue&type=template&id=372c8d72&scoped=true&"
import script from "./AboutImage.vue?vue&type=script&lang=js&"
export * from "./AboutImage.vue?vue&type=script&lang=js&"
import style0 from "./AboutImage.vue?vue&type=style&index=0&id=372c8d72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372c8d72",
  null
  
)

export default component.exports